import iconeSucessoRobo from "static/cloud21/icones/sucesso-icone-robo.svg";
import { makeStyles } from "@material-ui/core";


const stylesAtivacaoGroupPayIniciada = makeStyles({
  containerCentralizado: {
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
  },
})

const SucessoFestivoIcon: React.FC = () => {
    const styles = stylesAtivacaoGroupPayIniciada();
  return (
    <>
      <div className={styles.containerCentralizado}>
        {/* <img src={gifFesta} style={{ height: "150px"}} alt="gif-de-festa" /> */}
        <img src={iconeSucessoRobo} alt="icone-sucesso" />
      </div>
    </>
  );
};

export default SucessoFestivoIcon;
